<div class="h-full w-full flex flex-col" (windowResized)="onWindowResized($event)">
    <!-- Day Labels -->
    <div class="flex flex-row items-center justify-center" [style.width]="toolbarWidth">
        <span
            [pTooltip]="timezoneTooltip"
            tooltipPosition="top"
            class="w-10 bp908:w-[41px] mr-[3px] text-muted-color text-10 text-right cursor-default"
            >{{ timeZoneAbbr }}</span
        >
        @for (day of days; track day.startOfDayInMs; let i = $index) {
            <div
                class="h-full flex-1 text-left border-p-divider-border-color last:rounded-tr-lg border-r border-t border-b p-2"
                [ngClass]="{
                    'rounded-tl-lg border-l': i === 0,
                    'bg-today-color': day.isToday,
                    'animation-slide-left-and-fade-in': day.slideDirection === 'left',
                    'animation-slide-right-and-fade-in': day.slideDirection === 'right',
                }"
                ><span
                    class="font-inter text-muted-color text-14 font-medium"
                    [ngClass]="{
                        '!text-primary': day.isToday,
                        'text-muted-color/50': day.isPast,
                    }"
                    >{{
                        day.startOfDayInMs
                            | epochToTime: { format: 'ddd D', timezone: this.timezone }
                    }}</span
                ></div
            >
        }
    </div>

    <!-- Timeslots -->
    <div #scrollPanel class="w-full h-[calc(100%_-_36px)] overflow-y-auto overflow-x-hidden">
        <div class="flex flex-row">
            <fm-calendar-timeslot-labels
                [timeFormat]="timeFormat"
                class="w-10 bp908:w-[41px] mr-[3px]" />
            @for (day of days; track day.startOfDayInMs; let i = $index) {
                <fm-calendar-day
                    [isToday]="day.isToday"
                    [dayData]="calendarDayData[i]"
                    [sessionDuration]="sessionDuration"
                    [timezone]="timezone"
                    [timeFormat]="timeFormat"
                    [isFirstDay]="i === 0"
                    [isLastDay]="i === days.length - 1"
                    class="flex-grow border-r border-p-divider-border-color last:rounded-br-lg"
                    [ngClass]="{
                        'border-x border-x-p-content-border-color rounded-bl-lg': i === 0,
                        'animation-slide-left-and-fade-in': day.slideDirection === 'left',
                        'animation-slide-right-and-fade-in': day.slideDirection === 'right',
                    }" />
            }
        </div>
    </div>
</div>
